// DASS-42 Assessment Questions
// Depression (d), Anxiety (a), Stress (s) subscales

export const dass42Questions = [
  {
    id: 1,
    type: 's', // stress
    question: "I found myself getting upset by quite trivial things",
    questionFil: "Nagiging upset ako sa mga maliit na bagay",
    examples: [
      "Getting angry when someone takes too long at checkout",
      "Feeling frustrated when your phone battery dies",
      "Being annoyed by loud chewing sounds"
    ],
    examplesFil: [
      "Nagagalit kapag matagal ang pila sa cashier",
      "Naiinis kapag naubos ang battery ng phone",
      "Nababadtrip sa malakas na nguya"
    ]
  },
  {
    id: 2,
    type: 'a', // anxiety
    question: "I was aware of dryness of my mouth",
    questionFil: "Naramdaman ko ang pagkatuyo ng aking bibig",
    examples: [
      "Noticing your mouth feels dry during a presentation",
      "Feeling like you need water even though you just drank",
      "Your mouth feeling sticky or uncomfortable"
    ],
    examplesFil: [
      "Naramdaman na tuyo ang bibig habang nagsasalita sa harap",
      "Pakiramdam na kailangan ng tubig kahit kakainon lang",
      "Pakiramdam na malagkit o hindi komportable ang bibig"
    ]
  },
  {
    id: 3,
    type: 'd', // depression
    question: "I couldn't seem to experience any positive feeling at all",
    questionFil: "Hindi ko naramdaman ang anumang positibong damdamin",
    examples: [
      "Not feeling happy even when good things happen",
      "Feeling emotionally numb or empty inside",
      "Unable to enjoy activities you used to love"
    ],
    examplesFil: [
      "Hindi natutuwa kahit may magandang nangyari",
      "Pakiramdam na walang laman o manhid sa loob",
      "Hindi na nae-enjoy ang mga dating gustong gawain"
    ]
  },
  {
    id: 4,
    type: 'a',
    question: "I experienced breathing difficulty (eg, excessively rapid breathing, breathlessness in the absence of physical exertion)",
    questionFil: "Nakaranas ako ng hirap sa paghinga (tulad ng mabilis na paghinga, hingal kahit walang physical activity)",
    examples: [
      "Feeling short of breath while sitting still",
      "Breathing faster than normal when nervous",
      "Feeling like you can't catch your breath during stress"
    ],
    examplesFil: [
      "Nahihirapang huminga kahit nakaupo lang",
      "Mas mabilis ang paghinga kapag kinakabahan",
      "Pakiramdam na hindi makahinga ng maayos kapag stressed"
    ]
  },
  {
    id: 5,
    type: 'd',
    question: "I just couldn't seem to get going",
    questionFil: "Hindi ko masimulan ang mga gawain",
    examples: [
      "Struggling to start homework or assignments",
      "Feeling too tired to begin daily tasks",
      "Procrastinating on things you need to do"
    ],
    examplesFil: [
      "Hirap magsimula ng homework o assignments",
      "Pakiramdam na masyadong pagod para magsimula ng gawain",
      "Palaging nagiging later ang mga dapat gawin"
    ]
  },
  {
    id: 6,
    type: 's',
    question: "I tended to over-react to situations",
    questionFil: "May tendency akong mag-over-react sa mga sitwasyon",
    examples: [
      "Getting very upset over small mistakes",
      "Reacting strongly to minor criticism",
      "Making a big deal out of small problems"
    ],
    examplesFil: [
      "Sobrang upset sa maliliit na pagkakamali",
      "Malakas na reaksyon sa maliit na kritisismo",
      "Ginagawang malaking problema ang maliliit na bagay"
    ]
  },
  {
    id: 7,
    type: 'a',
    question: "I had a feeling of shakiness (eg, legs going to give way)",
    questionFil: "Naramdaman ko ang panginginig (tulad ng parang mawawalan ng lakas ang mga binti)",
    examples: [
      "Feeling your hands shake when nervous",
      "Legs feeling weak or unsteady",
      "Trembling when speaking in public"
    ],
    examplesFil: [
      "Nanginginig ang kamay kapag kinakabahan",
      "Pakiramdam na mahina o hindi steady ang mga binti",
      "Nanginginig kapag nagsasalita sa harap ng marami"
    ]
  },
  {
    id: 8,
    type: 's',
    question: "I found it difficult to relax",
    questionFil: "Nahirapan akong mag-relax",
    examples: [
      "Unable to unwind after a stressful day",
      "Feeling tense even during free time",
      "Mind racing when trying to rest"
    ],
    examplesFil: [
      "Hindi makapag-relax pagkatapos ng stressful na araw",
      "Pakiramdam na tense kahit free time",
      "Umiikot ang isip kapag sinusubukang magpahinga"
    ]
  },
  {
    id: 9,
    type: 'a',
    question: "I found myself in situations that made me so anxious I was most relieved when they ended",
    questionFil: "Natagpuan ko ang sarili ko sa mga sitwasyong nakakapag-anxious na sobrang relieved ako kapag tapos na",
    examples: [
      "Feeling anxious during job interviews or exams",
      "Being nervous at social gatherings",
      "Dreading presentations or public speaking"
    ],
    examplesFil: [
      "Kinakabahan sa job interview o exams",
      "Nerbiyoso sa mga social gatherings",
      "Takot sa presentations o pagsasalita sa harap"
    ]
  },
  {
    id: 10,
    type: 'd',
    question: "I felt that I had nothing to look forward to",
    questionFil: "Naramdaman ko na walang akong inaasahan sa hinaharap",
    examples: [
      "Feeling like there's nothing exciting coming up",
      "Not having goals or plans that motivate you",
      "Feeling hopeless about the future"
    ],
    examplesFil: [
      "Pakiramdam na walang exciting na darating",
      "Walang goals o plano na nag-motivate",
      "Walang pag-asa sa hinaharap"
    ]
  },
  {
    id: 11,
    type: 's',
    question: "I found myself getting upset rather easily",
    questionFil: "Nagiging upset ako nang madali"
  },
  {
    id: 12,
    type: 's',
    question: "I felt that I was using a lot of nervous energy",
    questionFil: "Naramdaman ko na gumagamit ako ng maraming nervous energy"
  },
  {
    id: 13,
    type: 'd',
    question: "I felt sad and depressed",
    questionFil: "Naramdaman ko na malungkot at depressed ako"
  },
  {
    id: 14,
    type: 's',
    question: "I found myself getting impatient when I was delayed in any way (eg, lifts, traffic lights, being kept waiting)",
    questionFil: "Nagiging impatient ako kapag may delay (tulad sa elevator, traffic lights, o kapag pinapahintay)"
  },
  {
    id: 15,
    type: 'a',
    question: "I had a feeling of faintness",
    questionFil: "Naramdaman ko na parang mahihimatay ako"
  },
  {
    id: 16,
    type: 'd',
    question: "I felt that I had lost interest in just about everything",
    questionFil: "Naramdaman ko na nawala ang interest ko sa lahat ng bagay"
  },
  {
    id: 17,
    type: 'd',
    question: "I felt I wasn't worth much as a person",
    questionFil: "Naramdaman ko na hindi ako gaanong mahalaga bilang tao"
  },
  {
    id: 18,
    type: 's',
    question: "I felt that I was rather touchy",
    questionFil: "Naramdaman ko na medyo sensitive o touchy ako"
  },
  {
    id: 19,
    type: 'a',
    question: "I perspired noticeably (eg, hands sweaty) in the absence of high temperatures or physical exertion",
    questionFil: "Nakapagpawis ako nang halata (tulad ng basa ang kamay) kahit hindi mainit o walang physical activity"
  },
  {
    id: 20,
    type: 'a',
    question: "I felt scared without any good reason",
    questionFil: "Naramdaman ko na natakot ako nang walang magandang dahilan"
  },
  {
    id: 21,
    type: 'd',
    question: "I felt that life wasn't worthwhile",
    questionFil: "Naramdaman ko na hindi sulit ang buhay"
  },
  {
    id: 22,
    type: 's',
    question: "I found it hard to wind down",
    questionFil: "Nahirapan akong mag-relax o magpahinga"
  },
  {
    id: 23,
    type: 'a',
    question: "I had difficulty in swallowing",
    questionFil: "Nahirapan akong lumunok"
  },
  {
    id: 24,
    type: 'd',
    question: "I couldn't seem to get any enjoyment out of the things I did",
    questionFil: "Hindi ko naramdaman ang kasiyahan sa mga ginagawa ko"
  },
  {
    id: 25,
    type: 'a',
    question: "I was aware of the action of my heart in the absence of physical exertion (eg, sense of heart rate increase, heart missing a beat)",
    questionFil: "Naramdaman ko ang tibok ng puso ko kahit walang physical activity (tulad ng mabilis na tibok o parang may nakalimutang tibok)"
  },
  {
    id: 26,
    type: 'd',
    question: "I felt down-hearted and blue",
    questionFil: "Naramdaman ko na malungkot at down ako"
  },
  {
    id: 27,
    type: 's',
    question: "I found that I was very irritable",
    questionFil: "Naramdaman ko na sobrang irritable ako"
  },
  {
    id: 28,
    type: 'a',
    question: "I felt I was close to panic",
    questionFil: "Naramdaman ko na malapit na akong ma-panic"
  },
  {
    id: 29,
    type: 's',
    question: "I found it hard to calm down after something upset me",
    questionFil: "Nahirapan akong kumalma pagkatapos ma-upset"
  },
  {
    id: 30,
    type: 'a',
    question: "I feared that I would be 'thrown' by some trivial but unfamiliar task",
    questionFil: "Natakot ako na ma-overwhelm sa mga simpleng pero hindi pamilyar na gawain"
  },
  {
    id: 31,
    type: 'd',
    question: "I was unable to become enthusiastic about anything",
    questionFil: "Hindi ako naging enthusiastic sa anumang bagay"
  },
  {
    id: 32,
    type: 's',
    question: "I found it difficult to tolerate interruptions to what I was doing",
    questionFil: "Nahirapan akong tanggapin ang mga interruptions sa ginagawa ko"
  },
  {
    id: 33,
    type: 's',
    question: "I was in a state of nervous tension",
    questionFil: "Nasa estado ako ng nervous tension"
  },
  {
    id: 34,
    type: 'd',
    question: "I felt I was pretty worthless",
    questionFil: "Naramdaman ko na walang kwenta ako"
  },
  {
    id: 35,
    type: 's',
    question: "I was intolerant of anything that kept me from getting on with what I was doing",
    questionFil: "Hindi ko matanggap ang mga bagay na nakakaabala sa aking ginagawa"
  },
  {
    id: 36,
    type: 'a',
    question: "I felt terrified",
    questionFil: "Naramdaman ko na sobrang takot ako"
  },
  {
    id: 37,
    type: 'd',
    question: "I could see nothing in the future to be hopeful about",
    questionFil: "Walang nakikita sa hinaharap na pwedeng pag-asahan"
  },
  {
    id: 38,
    type: 'd',
    question: "I felt that life was meaningless",
    questionFil: "Naramdaman ko na walang kahulugan ang buhay"
  },
  {
    id: 39,
    type: 's',
    question: "I found myself getting agitated",
    questionFil: "Nagiging agitated o restless ako"
  },
  {
    id: 40,
    type: 'a',
    question: "I was worried about situations in which I might panic and make a fool of myself",
    questionFil: "Nag-alala ako sa mga sitwasyong maaari akong ma-panic at mapahiya"
  },
  {
    id: 41,
    type: 'a',
    question: "I experienced trembling (eg, in the hands)",
    questionFil: "Nakaranas ako ng panginginig (tulad sa mga kamay)"
  },
  {
    id: 42,
    type: 'd',
    question: "I found it difficult to work up the initiative to do things",
    questionFil: "Nahirapan akong mag-simula o gumawa ng mga bagay"
  }
];

// Rating scale options
export const dass42RatingScale = [
  {
    value: 0,
    label: "Did not apply to me at all",
    labelFil: "Hindi ako naapektuhan nito"
  },
  {
    value: 1,
    label: "Applied to me to some degree, or some of the time",
    labelFil: "Naapektuhan ako nito ng konti o minsan"
  },
  {
    value: 2,
    label: "Applied to me to a considerable degree or a good part of time",
    labelFil: "Naapektuhan ako nito ng malaki o madalas"
  },
  {
    value: 3,
    label: "Applied to me very much or most of the time",
    labelFil: "Naapektuhan ako nito ng sobra o halos palagi"
  }
];

// Scoring function
export const calculateDASS42Scores = (responses) => {
  let depression = 0;
  let anxiety = 0;
  let stress = 0;

  dass42Questions.forEach((question, index) => {
    const response = responses[index] || 0;
    
    switch (question.type) {
      case 'd':
        depression += response;
        break;
      case 'a':
        anxiety += response;
        break;
      case 's':
        stress += response;
        break;
    }
  });

  // DASS-42 scores: raw totals (0-42 per subscale, 0-126 total)
  return {
    depression: depression,
    anxiety: anxiety,
    stress: stress,
    total: depression + anxiety + stress
  };
};

// Severity interpretation for DASS-42 (raw scores 0-42 per subscale)
export const getDASS42Severity = (scores) => {
  const getSeverityLevel = (score, thresholds) => {
    if (score <= thresholds.normal) return 'Normal';
    if (score <= thresholds.mild) return 'Mild';
    if (score <= thresholds.moderate) return 'Moderate';
    if (score <= thresholds.severe) return 'Severe';
    return 'Extremely Severe';
  };

  return {
    depression: getSeverityLevel(scores.depression, {
      normal: 9,
      mild: 13,
      moderate: 20,
      severe: 27
    }),
    anxiety: getSeverityLevel(scores.anxiety, {
      normal: 7,
      mild: 9,
      moderate: 14,
      severe: 19
    }),
    stress: getSeverityLevel(scores.stress, {
      normal: 14,
      mild: 18,
      moderate: 25,
      severe: 33
    })
  };
};

// DASS-42 subscale item mappings
export const dass42Subscales = {
  depression: [3, 5, 10, 13, 16, 17, 21, 24, 26, 31, 34, 37, 38, 42],
  anxiety: [2, 4, 7, 9, 15, 19, 20, 23, 25, 28, 30, 36, 40, 41],
  stress: [1, 6, 8, 11, 12, 14, 18, 22, 27, 29, 32, 33, 35, 39]
};
